<template>
    <v-card>
        <v-card-title>
            Logs
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="desserts"
                :search="search"
                :items-per-page="-1"
        ></v-data-table>
    </v-card>
</template>

<script>
    import webLog from "../websql/weblog";
    export default {
        created(){
            this.getLogData();
        },
        data () {
            return {
                search: '',
                headers: [
                    { text: 'Timestamp', value: 'timestamp' },
                    { text: 'Status', value: 'status' },
                    { text: 'Message', value: 'message' }
                ],
                desserts: [],
            }
        },
        methods : {
            getLogData: function () {
                webLog.getLogs(this.updateLog);
            },
            updateLog : function (logs) {
                this.desserts = logs
            }
        }
    }
</script>

<style scoped>

</style>